import SEO from "@/components/shared/SEO";
import TermsOfServices from "@/components/terms-and-conditions/TermsOfServices";

export default function TermsOfServicePageComponent() {
	return (
		<>
			<SEO title="OCP Terms of Service" />
			<main className="w-full space-y-4 px-20 py-12">
				<TermsOfServices usageContext="page" />
			</main>
		</>
	);
}
